require("../modules/es.global-this");

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVzbmV4dC5nbG9iYWwtdGhpcy5qcyJdLCJuYW1lcyI6WyJyZXF1aXJlIl0sIm1hcHBpbmdzIjoiQUFDQUEsUUFBUSIsImZpbGUiOiIvaG9tZS9zcmMvYXBwL25vZGVfbW9kdWxlcy9jb3JlLWpzL21vZHVsZXMvZXNuZXh0Lmdsb2JhbC10aGlzLmpzIn0=